import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import Spinner from 'components/Credit24/Core/Spinner';
import LoanStepError from 'components/Credit24/LoanApplication/LoanStepError';
import { getSubdomain } from 'utils/environment';
import { DOMAINS } from 'consts/domains';

const propTypes = {
  authentication: PropTypes.object.isRequired,
};

const HomepageIncreaseAUContainer = ({ authentication }) => {
  const subdomain = getSubdomain(window.location.hostname);
  const isLocalhost = subdomain === DOMAINS.LOCALHOST;
  const localSelfServiceOrigin = `${window.location.protocol}//${window.location.hostname}:3000`;
  const selfServiceUrl = isLocalhost
    ? `${localSelfServiceOrigin}/ipf-demo/au/self-service/`
    : '/au/self-service';

  if (!authentication.isAuthenticated && !authentication.isLoading) {
    return (
      <div className="container container--mobile-fullWidth">
        <div className="loan-form">
          <LoanStepError
            title={<FormattedMessage id="increase_app.home.title" />}
            text={
              <FormattedMessage id="increase_app.home.message" />
            }
            button={(
              <a className="btn" href={selfServiceUrl}>
                <FormattedMessage id="increase_app.home.button" />
              </a>
            )}
          />
        </div>
      </div>
    );
  }

  return (
    <Spinner />
  );
};

HomepageIncreaseAUContainer.propTypes = propTypes;

export default connect(
  (state) => ({
    authentication: state.authentication,
  })
)(HomepageIncreaseAUContainer);
